export default __webpack_public_path__ + "static/media/Oreo.cd8b3ac0.png";